import { TokenStorageService } from 'src/app/core/security/token-storage-service';
import { Injectable } from '@angular/core';
import { CurrentUserService } from 'src/app/core/services/current-user.service';
import { GAIds } from '../../enum/ga-ids.enum';
import { environment } from 'src/environments/environment';
import * as _  from 'lodash';

declare const ga: any

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {

  constructor(private _currentUserSvc: CurrentUserService, private _tokenService: TokenStorageService) {
  }

  /**
   * Register google analytics
   * @param action
   * @param label
   * @param persona
   */
  public async register(action: string, label: string, persona: string = null) {
    if (!persona) {
      persona = ((await this._currentUserSvc.getUserInfo()) || {}).organizationName;
    }

    await this._setup();
    ga('send', 'event', action, label, persona);
  }

  private async _setup() {
    try {
      // Analytic id based on environment
      const analyticsId = GAIds[(environment.runtime.envName || 'prod').toUpperCase()];
      ga('create', analyticsId, 'auto');

      const user = await this._currentUserSvc.getUserInfo();
      const username = await this._getUsername(user);
      // attach dimensions for each ga calls

      if (user && user.organizationName && user.organizationType) {
        (<any>window).ga('set', 'dimension1', username.toUpperCase());
        (<any>window).ga('set', 'dimension2', (user.organizationName).toUpperCase());
        (<any>window).ga('set', 'dimension3', (user.organizationType).toUpperCase());
      }
    } catch (err) {
      return {};
    }
  }

  /**
   * Get username
   * current username if user is not impersonator
   * impersonator username if user is impersonator
   * @param currUser
   */
  private async _getUsername(currUser) {
    try {
      const user = (await this._tokenService.isImpersonator()) ? JSON.parse(JSON.parse(await this._tokenService.getImpersonator()).user) : currUser;
      return user.username;
    } catch (err) {
      return '';
    }
  }
}
